import React, { useEffect, useLayoutEffect, Fragment, useState } from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import { slickDot } from "../page-demo/script";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import ServiceList from "../elements/service/ServiceList";
import FooterTwo from "../component/footer/FooterTwo";
import Contact from "../elements/contact/ContactTwo";
import Helmet from "../component/common/Helmet";
import logoXrai from "../assets/images/logo/xrailogo.png";
import logoLight from "../assets/images/logo/logo-light.png";
import logoAllDark from "../assets/images/logo/logo-all-dark.png";

import aboutImg from "../assets/images/about/about.png";
import TabsTwo from "../elements/tab/TabTwo";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { apiProductsState } from "../atom/Products";
import { getCookie, removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";
import { useHistory } from "react-router-dom";
import { apiKeyState } from "../atom/ApiKey";
import { ApiProducts } from "../api/apiKey/ApiProducts";
import { ApiList } from "../api/apiKey/ApiList";
import { ListJoinState, categoryListState } from "../atom/BorderPage";
import { BorderCategory } from "../api/border/BorderApi";
export const SlideList = [
  {
    textPosition: "text-center",
    category: "",
    title: "eXplainable Reliable AI",
    description: "사업화를 위한 AI솔루션이 필요하신가요?",
    description2:
      "XRAI는 고객이 원하는 서비스를 제공하기까지 최선을 다하여 프로젝트를 끝까지 도와드립니다.",
    buttonText: "Contact Us",
    buttonLink: "#contact",
  },
];
const list = [
  {
    image: "image-1",
    category: "모하(MOHA)",
    title: "유아 사진 자동 분류 서비스",
  },
  {
    image: "image-2",
    category: "피쉬렌즈",
    title: "어종검출어플리케이션",
  },
  {
    image: "image-3",
    category: "후원한잔",
    title: "블로그 후원서비스",
  },
  {
    image: "image-4",
    category: "AI 프로필",
    title: "AI 캐리커쳐 생성",
  },
  {
    image: "image-5",
    category: "Vibe Up",
    title: "SNS 서비스",
  },
  {
    image: "image-6",
    category: "API 서비스",
    title: "건강 데이터 조회",
  },
  {
    image: "image-7",
    category: "API 서비스",
    title: "광학문자 인식 서비스",
  },
  {
    image: "image-8",
    category: "Bot",
    title: "Chat Bot 제작 서비스",
  },
];

const CreativeLanding = () => {
  const history = useHistory();
  const location = useLocation();
  const apiProducts = useRecoilValue(apiProductsState);
  const [isToken, setToken] = useState(false);
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const setCategories = useSetRecoilState(categoryListState);
  const categories = useRecoilValue(categoryListState);

  useEffect(() => {
    const categoryGet = async () => {
      try {
        const resp = await BorderCategory();

        const modified = {
          current: 0,
          data: [{ id: 0, text: "전체" }, ...resp.data],
        };
        setCategories(modified);
      } catch (error) {
        console.log("Error", error);
        return;
      }
    };
    categoryGet();
  }, []);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };
  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };

  useEffect(() => {
    const handleData = async () => {
      const apipro = await ApiProducts();
      const apiKey = await ApiList();
      if (apipro?.data) {
        setPriducts(apipro?.data);
      }

      if (apiKey?.data) {
        setApiKeys(apiKey?.data);
      }
    };

    const token = getCookie(TokenName);

    if (!token) {
      setToken(true);
    } else {
      setToken(false);
      handleData();
    }
  }, []);

  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={[
                  "home",
                  "company",
                  "solution",
                  "portfolio",
                  // "blog",
                  "contact",
                ]}
                currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#company">Company</a>
                </li>
                <li>
                  <a href="#solution">Solution</a>
                </li>
                <li>
                  <a href="#portfolio">Portfolio</a>
                </li>
                <li>
                  <a href="#contact" onClick={() => history.push("/border")}>
                    Contact
                  </a>
                </li>
                {/* <li>
                  <a href="/border">Community</a>
                </li> */}
                <li>
                  {isToken === true ? (
                    <a href="login">Login</a>
                  ) : (
                    <a
                      style={{
                        cursor: `pointer`,
                      }}
                      onClick={() => haderLogout()}
                    >
                      Logout
                    </a>
                  )}
                </li>
              </Scrollspy>
            </nav>
            {/* <div className="header-btn">
              <a
                className="rn-btn"
                href="https://themeforest.net/checkout/from_item/25457315?license=regular"
              >
                <span>buy now</span>
              </a>
            </div> */}
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={menuTrigger} className="menutrigger text-white">
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={closeMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
      {/* End Header Area  */}

      {/* Start Slider Area   */}
      <div className="slider-activation slider-creative-agency" id="home">
        <div className="bg_image bg_image--main" data-black-overlay="6">
          {SlideList.map((value, index) => (
            <div
              className="slide slide-style-2 slider-paralax d-flex align-items-center justify-content-center"
              key={index}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className={`inner ${value.textPosition}`}>
                      {value.category ? <span>{value.category}</span> : ""}
                      {value.title ? (
                        <h1
                          className="title theme-gradient"
                          style={{ "text-transform": "none" }}
                        >
                          {value.title}
                        </h1>
                      ) : (
                        ""
                      )}
                      {value.description ? (
                        <p
                          className="description"
                          style={{ fontWeight: `bold` }}
                        >
                          {value.description}
                        </p>
                      ) : (
                        ""
                      )}
                      {value.description2 ? (
                        <p
                          className="description"
                          style={{ padding: "0", fontWeight: `bold` }}
                        >
                          {value.description2}
                        </p>
                      ) : (
                        ""
                      )}
                      {value.buttonText ? (
                        <div className="slide-btn">
                          <a
                            className="rn-button-style--2 btn-primary-color"
                            href={`${value.buttonLink}`}
                          >
                            {value.buttonText}
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* End Slider Area   */}

      {/* Start About Area */}
      <div className="about-area ptb--120 bg_color--5" id="company">
        <div className="about-wrapper">
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-5">
                <div className="thumbnail">
                  <img className="w-100" src={aboutImg} alt="About Images" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="about-inner inner">
                  <div className="section-title">
                    <h2 className="title">AI 전문기업 XRAI 입니다.</h2>
                    <p
                      className="description"
                      style={{
                        color: `black`,
                        fontSize: `18px`,
                        fontWeight: `normal`,
                      }}
                    >
                      XRAI는 탁원한 전문성을 바탕으로 고객들이 원하는 AI
                      솔루션의 사업화에 적극적으로 동참합니다.
                      <br />
                      누구나 쉽게 AI서비스에 접근할 수 있도록 고객의 입장에서
                      생각합니다.
                      <br />
                      XRAI는 AI개발 전문 컴퍼니로써 고객사에 성공적인 프로젝트를
                      합리적인 가격으로 제공드릴 것을 약속드립니다.
                    </p>
                  </div>
                  <div className="row mt--30">
                    <TabsTwo tabStyle="tab-style--1" />
                  </div>
                </div>
              </div>
              {/* <div className="row mt--30">
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="about-us-list">
                        <h3 className="title">연혁</h3>
                        <p>
                          There are many vtions of passages of Lorem Ipsum
                          available, but the majority have suffered.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                      <div className="about-us-list">
                        <h3 className="title">Who we are</h3>
                        <p>
                          There are many vtions of passages of Lorem Ipsum
                          available, but the majority have suffered.
                        </p>
                      </div>
                    </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* End About Area */}

      {/* Start Service Area  */}
      <div
        className="service-area creative-service-wrapper ptb--120 bg_color--1"
        id="solution"
      >
        <div className="container">
          <div className="row creative-service">
            <div className="col-lg-12">
              <ServiceList
                item="8"
                column="col-lg-3 col-md-6 col-sm-6 col-12 text-left"
              />
            </div>
          </div>
        </div>
      </div>
      {/* End Service Area  */}
      {/* Start Portfolio Area */}
      <div
        className="portfolio-area pt--120 pb--140 bg_color--1"
        id="portfolio"
      >
        <div className="rn-slick-dot">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="section-title service-style--3 text-left mb--15 mb_sm--0">
                  <h2 className="title">Portfolio</h2>
                  <p style={{ fontWeight: `bold` }}>
                    성공적인 AI 솔루션 서비스를 위해 XRAI와 함께하세요!
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="slick-space-gutter--15 slickdot--20">
                  <Slider {...slickDot}>
                    {list.map((value, index) => (
                      <div className="portfolio" key={index}>
                        <div className="thumbnail-inner">
                          <div className={`thumbnail ${value.image}`}></div>
                          <div className={`bg-blr-image ${value.image}`}></div>
                        </div>
                        <div className="content">
                          <div className="inner">
                            <p>{value.category}</p>
                            <h4>
                              <a href="">{value.title}</a>
                            </h4>

                            <div className="portfolio-button">
                              {/* <a className="rn-btn" href="/portfolio-details">
                                Case Study
                              </a> */}
                            </div>
                          </div>
                        </div>
                        {/* <Link
                          className="link-overlay"
                          to=""
                        ></Link> */}
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Portfolio Area */}
      {/* Start Blog Area */}
      {/* <div className="rn-blog-area pt--120 pb--140 bg_color--1" id="blog">
        <div className="container">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <div className="section-title text-left">
                <h2>Latest News</h2>
                <p>
                  There are many variations of passages of Lorem Ipsum
                  available, but the majority have suffered alteration.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt--55 mt_sm--30 rn-slick-dot slick-space-gutter--15 slickdot--20 row--0">
            <div className="col-lg-12">
              <Slider {...slickDot}>
                {PostList.map((value, i) => (
                  <div className="blog blog-style--1" key={i}>
                    <div className="thumbnail">
                      <a href="/blog-details">
                        <img src={value.images} alt="Blog Images" />
                      </a>
                    </div>
                    <div className="content">
                      <p className="blogtype">{value.category}</p>
                      <h4 className="title">
                        <a href="/blog-details">{value.title}</a>
                      </h4>
                      <div className="blog-btn">
                        <a className="rn-btn text-white" href="/blog-details">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Blog Area */}

      {/* Start Contact Us */}
      <div className="rn-contact-us ptb--120 bg_color--5" id="contact">
        <Contact />
      </div>

      {/* End Contact Us */}

      {/* Start Brand Area */}
      {/* <div className="rn-brand-area bg_color--1 ptb--120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <BrandTwo />
            </div>
          </div>
        </div>
      </div> */}
      {/* End Brand Area */}

      {/* Start Footer Style  */}
      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default CreativeLanding;
